import {Component, ElementRef, OnInit, Input, NgZone, ViewChild, AfterViewInit, ViewChildren, Output, EventEmitter} from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { } from '@types/googlemaps';
import {forEach} from '@angular/router/src/utils/collection';
import {ModalService, PatientService} from '../../services';
import {MatStepper} from '@angular/material';

@Component({
    selector: 'app-alarm-zone',
    templateUrl: './alarm-zone.component.html',
    styleUrls: ['./alarm-zone.component.scss']
})
export class AlarmZoneComponent implements OnInit {

    @Input() imei;
    @Output() alarmZoneCount: EventEmitter<number> = new EventEmitter<number>();
    alarmZones = [];
    isLoading = true;
    measInterval;
    stepIndex = 0;
    alwaysNegative;

    @ViewChildren('search') searchElementRef;
    @ViewChild('stepper') stepper: MatStepper;

    constructor(
        private fb: FormBuilder,
        private mapsAPILoader: MapsAPILoader,
        private ngZone: NgZone,
        private patientService: PatientService,
        private modalService: ModalService
    ) { }

    ngOnInit() {
      this.alwaysNegative = this.fb.group({
        'valid': ['', [Validators.minLength(3)]]
      });
      this.alwaysNegative.patchValue({
        'valid': 'a'
      });
      this.alwaysNegative.updateValueAndValidity();
      this.getAlarmZone();
    }

    private setCurrentPosition(zone) {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
                zone.get('latitude').setValue(position.coords.latitude);
                zone.get('longitude').setValue(position.coords.longitude);
                this.getAddressFromLatLang(zone);
            });
        }
    }

    private getAddressFromLatLang(zone) {
        const geocoder = new google.maps.Geocoder;
        const latLng = new google.maps.LatLng(zone.get('latitude').value, zone.get('longitude').value);

        geocoder.geocode({
            'location': {
                lat: zone.get('latitude').value,
                lng: zone.get('longitude').value
            }
        }, (results, status) => {
            if (status.toString() === 'OK') {
                zone.get('latitude').setValue(zone.get('latitude').value);
                zone.get('longitude').setValue(zone.get('longitude').value);
                zone.get('address').setValue(results[0].formatted_address);
            }
        });

    }

    deleteZone(id) {
      this.modalService.openAccept('Usunięcie strefy spowoduje usunięcie niezapisanych zmian w pozostałych strefach alarmowych. Kontynuować?')
        .subscribe(res => {
          if (res.ok) {
            this.isLoading = true;
            this.patientService.deleteAlarmZone(id).subscribe(data => {
              this.getAlarmZone(true);
            });
          }
        });
    }

    submitForms() {
      const tmp = [];
      this.alarmZones.forEach(val => {
        tmp.push(val.value);
      });
      this.isLoading = true;
      this.patientService.setAlarmZones(this.imei, tmp).subscribe(data => {
        this.getAlarmZone();
      });
    }

    addZone() {
      if (this.alarmZones.length > 0) {
        this.modalService.openAccept('Dodanie nowej strefy spowoduje usunięcie niezapisanych zmian w pozostałych strefach alarmowych. Kontynuować?')
          .subscribe(res => {
            if (!res.ok) {
              return;
            } else {
              this.isLoading = true;
              this.patientService.addAlarmZone(this.imei).subscribe(data => {
                this.getAlarmZone(true);
              });
            }
        });
      } else {
        this.isLoading = true;
        this.patientService.addAlarmZone(this.imei).subscribe(data => {
          this.getAlarmZone(true);
        });
      }
    }

    getAlarmZone(goLastIndex: boolean = false) {
      this.alarmZones = [];
      this.patientService.getPatientAlarmZones(this.imei).subscribe(datum => {
        if (datum.length > 0) { this.measInterval = datum[0].interval; } else { this.measInterval = 15; }
        const tmpZones = [];
        let i = 0;
        datum.forEach(val => {
          const fg = this.fb.group({
            'id': [null],
            'index': i,
            'address': [null],
            'radius': [null],
            'latitude': [null],
            'longitude': [null],
            'interval': [null]
          });
          fg.patchValue({
            'id': val.id,
            'index': i,
            'address': val.address,
            'radius': val.radius,
            'latitude': val.lat,
            'longitude': val.lng,
            'interval': val.interval
          });
          tmpZones.push(fg);
          i += 1;
        });
        this.alarmZones = tmpZones;
        this.alarmZoneCount.emit(this.alarmZones.length);
        this.isLoading = false;
        this.ngZone.runOutsideAngular(() => {
          if (goLastIndex) { if (this.alarmZones.length > 0) { this.stepIndex = this.alarmZones.length - 1; } }
          // this.stepper._getIndicatorType = () => 'number';
        });
        this.setSearch();
      });
    }

    setSearch() {
      this.ngZone.runOutsideAngular(() => {
      // this.alarmZones.forEach(value => {
        this.mapsAPILoader.load().then(() => {
          // if (value.get('address').value) {
          //   this.setCurrentPosition(value);
          // }
          this.searchElementRef.forEach(search => {
            this['autocomplete' + search.nativeElement.id] = new google.maps.places.Autocomplete(search.nativeElement, {
              types: ['address']
            });
            this['autocomplete' + search.nativeElement.id].addListener('place_changed', () => {
              this.ngZone.run(() => {
                const place: google.maps.places.PlaceResult = this['autocomplete' + search.nativeElement.id].getPlace();
                if (place.geometry === undefined || place.geometry === null) {
                  return;
                }

                this.alarmZones[search.nativeElement.id].get('latitude').setValue(place.geometry.location.lat());
                this.alarmZones[search.nativeElement.id].get('longitude').setValue(place.geometry.location.lng());
                this.alarmZones[search.nativeElement.id].get('address').setValue(place.formatted_address);
              });
            });
          });
        });
      // });
      });
    }

    __parseFloat(val) {
      return parseFloat(val);
    }

    __parseInt(val) {
      return parseInt(val);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/alarm-zone/alarm-zone.component.ts